// React
import React from 'react';
import ReactDOM from 'react-dom/client';

// App
import App from './App';

// Styles
import './index.css';

// Stores
//import { store } from "./store/store.js";

// Theme
import Theme from "./theme/index.js";

// Packages
import { Provider } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";

import { store, persistor } from './store/store.js';
import { PersistGate } from 'redux-persist/integration/react';
import { Toaster } from 'react-hot-toast';

const theme = Theme;

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ThemeProvider theme={theme}>
        <App />
        <Toaster />
      </ThemeProvider>
    </PersistGate>
  </Provider>,
);